/**
 * General Email Utilities
 * Shared email validation logic across all PMS providers
 */

/**
 * Basic email validation using regex
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
